export const ErrorFallback = () => {
  const handleReload = () => {
    window.location.reload();
  };

  const handleGoHome = () => {
    window.location.href = "/";
  };

  return (
    <div className="flex h-screen w-full flex-col items-center justify-center px-4">
      <div className="flex max-w-md flex-col items-center text-center">
        <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
          <svg
            className="h-8 w-8 text-red-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
        </div>
        <h1 className="mb-2 text-2xl font-semibold text-gray-900">
          Xatolik yuz berdi
        </h1>
        <p className="mb-8 text-gray-600">
          Kutilmagan xatolik yuz berdi. Iltimos, sahifani qayta yuklang yoki
          bosh sahifaga qayting.
        </p>
        <div className="flex gap-3">
          <button
            type="button"
            onClick={handleGoHome}
            className="rounded-lg border border-gray-300 bg-white px-4 py-2.5 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50"
          >
            Bosh sahifa
          </button>
          <button
            type="button"
            onClick={handleReload}
            className="rounded-lg bg-blue-600 px-4 py-2.5 text-sm font-medium text-white shadow-sm hover:bg-blue-700"
          >
            Qayta yuklash
          </button>
        </div>
      </div>
    </div>
  );
};
